import { render, staticRenderFns } from "./notReviewTopics.vue?vue&type=template&id=f451661a&scoped=true&"
import script from "./notReviewTopics.vue?vue&type=script&lang=js&"
export * from "./notReviewTopics.vue?vue&type=script&lang=js&"
import style0 from "./notReviewTopics.vue?vue&type=style&index=0&id=f451661a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f451661a",
  null
  
)

export default component.exports